export default __webpack_public_path__ + "static/media/vp_safari.0f494df6.svg";